const clientId = process.env.REACT_APP_MSAL_CLIENT_ID || 'ec39786f-9998-4a43-aef9-2d8148338b0b';

export const msalConfig = {
  auth: {
    clientId: clientId,
    authority: 'https://login.microsoftonline.com/c4ea64ee-34b6-4a18-9339-8aff143c12d4',
    redirectUri: `${window.location.origin}/landing`,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: true,
  },
};

export const loginRequest = {
  scopes: [`api://${clientId}/access_as_user`],
};